/** Serialises async critical sections (store mutations), so a save, a pull and a push result can
 * never interleave. Within one page; across browser tabs the app also takes a Web Lock. */
export class Mutex {
    tail = Promise.resolve();
    run(fn) {
        const next = this.tail.then(fn, fn);
        this.tail = next.catch(() => { });
        return next;
    }
}
//# sourceMappingURL=mutex.js.map